export default function Smartphone({ className }) {
    return (
        <svg className={className} id="uuid-75e49c7e-604a-4293-9a75-e50487317853" data-name="Schrift" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.14 439.28">
          <path d="m300.23,318.51h-111.31V120.77h111.31v197.75Zm-68.1-222.63h24.62c3.4,0,6.29,2.88,6.29,6.29s-2.88,6.29-6.29,6.29h-24.62c-3.4,0-6.29-2.88-6.29-6.29s2.88-6.29,6.29-6.29Zm80.41-12.31h-135.93c-3.4,0-6.29,2.88-6.29,6.29v259.56c0,3.4,2.88,6.29,6.29,6.29h135.93c3.4,0,6.29-2.88,6.29-6.29V89.86c-.26-3.4-2.88-6.29-6.29-6.29Z" style="fill: #e20432; stroke-width: 0px;"/>
        </svg>
    );
  }
  